import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { AuthorizeService } from 'src/app/shared/authorizeService/authorize.service';
import { GenericResult } from 'src/app/globalClass/generic-class.model';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';

@Component({
  selector: 'app-forgot-pass',
  templateUrl: './forgot-pass.component.html',
  styleUrls: ['./forgot-pass.component.css']
})
export class ForgotPassComponent implements OnInit {

  constructor(
    private _fb:FormBuilder,
    private _authorizeService:AuthorizeService,
    private _toastr:ToastrService,
    private _router:Router

  ) { }

  ngOnInit() {
  }

  changeForm = this._fb.group({
    documento:["",[Validators.required]],
    email:["",Validators.required]
  });



  onSubmit(){
    let form = this.changeForm.value;
    this._authorizeService.sendTokenForgotPass(form).then(
      (r:GenericResult)=>{
        if(r.error){
          this._toastr.error("Un error ha ocurrido cuando se realizaba l envío de correo electrónico, por favor contacte con su administrador de servicios.")
        }else{
          this._router.navigate(["/login"]);
        }
      }
    )
    //Validar datos y si existe enviar mensaje con token de restaurar contraseña.
  }

}
